<template>
  <div class="image-upload-input">
    <div class="form-label" v-if="label">
      <label>{{ label }}</label>
    </div>
    
    <!-- Preview da imagem -->
    <div class="image-preview-wrapper" v-if="previewUrl">
      <div class="image-preview-container">
        <img 
          :src="previewUrl" 
          :alt="previewAlt || 'Preview'"
          class="image-preview"
        />
        <button 
          class="remove-preview-btn" 
          @click="removePreview"
          type="button"
          title="Remover imagem"
        >
          <fa icon="fa-times" />
        </button>
        <div class="image-overlay" v-if="showPlayIcon">
          <fa icon="fa-circle-play" />
        </div>
      </div>
    </div>

    <!-- Input de upload -->
    <div class="upload-container" v-if="!previewUrl || showInput">
      <div class="file-wrapper">
        <input
          :id="inputId"
          class="file-input"
          type="file"
          :accept="accept"
          @change="handleFileChange"
          :disabled="disabled"
        />
        <label :for="inputId" class="file-label">
          <div class="upload-icon">
            <fa icon="fa-image" />
          </div>
          <div class="upload-text">
            <span class="upload-title">{{ placeholder || 'Clique para fazer upload de imagem' }}</span>
            <span class="upload-subtitle">{{ acceptText || 'Formatos aceitos: PNG, JPG, WEBP' }}</span>
          </div>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageUploadInput',
  props: {
    label: {
      type: String,
      default: 'Capa do vídeo'
    },
    accept: {
      type: String,
      default: '.png, .jpg, .jpeg, .webp'
    },
    acceptText: {
      type: String,
      default: 'Tamanho: 854 × 480 px, apenas formato PNG e JPG'
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    previewUrl: {
      type: String,
      default: null
    },
    previewAlt: {
      type: String,
      default: 'Preview da imagem'
    },
    showInput: {
      type: Boolean,
      default: false
    },
    showPlayIcon: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      inputId: `image-upload-${Math.random().toString(36).substr(2, 9)}`
    };
  },
  methods: {
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.$emit('file-selected', file, event);
      }
    },
    removePreview() {
      this.$emit('remove-preview');
    }
  }
};
</script>

<style scoped>
.image-upload-input {
  width: 100%;
}

.form-label {
  margin-bottom: 0.75rem;
}

.form-label label {
  font-weight: 500;
  color: #1a1a1a;
  font-size: 0.875rem;
  display: block;
}

.image-preview-wrapper {
  margin-bottom: 1rem;
}

.image-preview-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  aspect-ratio: 16 / 9;
  background: #f4f5fa;
  border-radius: 10px;
  padding: 0;
  border: 0;
  overflow: hidden;
}

/* .image-preview {
  width: 100%;
  height: auto;
  max-height: 300px;
  object-fit: cover;
  border-radius: 8px;
  display: block;
} */
.image-preview {
  width: 100%;
  height: 100%;
  max-height: none;
  object-fit: contain;
  border-radius: 0;
  display: block;
  margin: 0;
}

.remove-preview-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  background: rgba(0, 0, 0, 0.7);
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: white;
  transition: all 0.2s ease;
  z-index: 10;
}

.remove-preview-btn:hover {
  background: rgba(220, 53, 69, 0.9);
  transform: scale(1.1);
}

.image-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 3rem;
  opacity: 0.9;
  pointer-events: none;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
  z-index: 5;
}

.upload-container {
  width: 100%;
}

.file-wrapper {
  position: relative;
  width: 100%;
}

.file-input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.file-label {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2.5rem 1.5rem;
  border: 1.5px dashed #b9adf9 !important;
  border-radius: 10px;
  background: #fbfaff;
  cursor: pointer;
  transition: border-color 150ms ease, background-color 150ms ease;
  text-align: center;
  min-height: 140px;
  height: auto;
}

.file-label:hover {
  border-color: #150065;
  background: #fafbfc;
  box-shadow: 0 2px 8px rgba(21, 0, 101, 0.08);
}

.file-label:active {
  transform: translateY(0);
}

.file-input:disabled + .file-label {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}

.upload-icon {
  margin-bottom: 1rem;
  color: #150065;
  font-size: 3rem;
  opacity: 0.8;
  transition: all 0.3s ease;
}

.file-label:hover .upload-icon {
  opacity: 1;
  transform: scale(1.1);
}

.upload-text {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.upload-title {
  font-weight: 600;
  color: #1a1a1a;
  font-size: 1rem;
}

.upload-subtitle {
  font-size: 0.75rem;
  color: #6b7280;
}

@media (max-width: 768px) {
  .file-label {
    padding: 2rem 1rem;
    min-height: 160px;
  }

  .upload-icon {
    font-size: 2.5rem;
  }

  .image-preview {
    max-height: 250px;
  }
}
</style>

